<template>
	<div>
		<div class="d-flex justify-content-between">
			<h1 class="page-header">{{ $t('monthlyExpenseItem.pageTitle') }}</h1>
			<ts-breadcrumb :items="[
				{ text: $t('home'), href: '/' },
				{
					text: $t('monthlyExpenseItem.pageTitle'),
					active: true
				}
			]" />
		</div>
		<div class="row">
			<div class="col-md-3">
				<ts-card>
					<ts-card-wrapper>
						<ts-loading-banner :loading="loading">
							<form>
								<fieldset>
									<legend>{{ $t('monthlyExpenseItem.criteria') }}</legend>
									<div class="row form-group">
										<div class="col-md-12">
											<label class="required">{{ $t('monthlyExpenseItem.date') }}</label>
											<a-range-picker style="width: 100%" :mode="mode" format="MM-YYYY"
												v-model="month_range" valueFormat="MM-YYYY"
												@panelChange="handlePanelChange" />
										</div>
									</div>
									<div class="row form-group">
										<div class="col-md-12">
											<label>{{ $t('monthlyExpenseItem.branch') }}</label>
											<a-select v-model="model.branch_id" mode="multiple" showSearch
												:options="branches" class="ts-w-full" @change="onChangeBranch"
												:placeholder="$t('all')" :filterOption="(input, option) =>
													option.componentOptions.children[0].text
														.toLowerCase()
														.indexOf(input.toLowerCase()) >= 0
													"></a-select>
										</div>
									</div>
									<div class="row form-group">
										<div class="col-md-12">
											<label class="">{{
												$t('monthlyExpenseItem.warehourse')
											}}</label>
											<a-select v-model="model.location_id" mode="multiple"
												:defaultActiveFirstOption="true" showSearch :filterOption="(input, option) =>
													option.componentOptions.children[0].text
														.toLowerCase()
														.indexOf(input.toLowerCase()) >= 0
													" :options="locations" class="ts-w-full" :placeholder="$t('all')"></a-select>
										</div>
									</div>
									<div class="row form-group">
										<div class="col-md-12">
											<label>{{
												$t('monthlyExpenseItem.category')
											}}</label>
											<a-select v-model="model.exp_cat_id" :options="categories" mode="multiple"
												showSearch :filterOption="(input, option) =>
													option.componentOptions.children[0].text
														.toLowerCase()
														.indexOf(input.toLowerCase()) >= 0
													" class="ts-w-full" :placeholder="$t('all')"></a-select>
										</div>
									</div>
									<div class="row form-group">
										<div class="col-md-12">
											<label>{{ $t('monthlyExpenseItem.expenseItem') }}</label>
											<a-select v-model="model.exp_id" :options="items" showSearch
												:filterOption="(input, option) => option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0"
												placeholder="All" mode="multiple" class="ts-w-full"></a-select>
										</div>
									</div>
									<div class="row form-group">
										<div class="col-md-12">
											<label>{{
												$t('monthlyExpenseItem.expenseBy')
											}}</label>
											<ts-loading-banner :loading="employeeLoading">
												<a-select v-model="model.employee_id" :options="employees" class="ts-w-full"
													showSearch :filterOption="(input, option) =>
														option.componentOptions.children[0].text
															.toLowerCase()
															.indexOf(input.toLowerCase()) >= 0
														" placeholder="All" mode="multiple"></a-select>
											</ts-loading-banner>
										</div>
									</div>
									<div class="row form-group">
										<div class="col-md-12">
											<label>{{
												$t('monthlyExpenseItem.reportType')
											}}</label>
											<div class="row form-group">
												<a-radio-group v-model="model.report_type" class="col-md-12">
													<a-radio-button :value="1" class="col-md-6">Details</a-radio-button>
													<a-radio-button :value="2" class="col-md-6">Summary</a-radio-button>
												</a-radio-group>
											</div>
										</div>
									</div>
									<div class="row">
										<div class="col-md-6 text-right">
											<ts-button class="btn-block" outline color="success"
												@click.prevent="exportExcel" :waiting="exporting"><i
													class="fas fa-file-excel"></i>
												{{ $t('excel') }}</ts-button>
										</div>
										<div class="col-md-6 text-right">
											<ts-button class="btn-block" color="primary" @click.prevent="preview"
												:waiting="waiting"><i class="fas fa-file-pdf text-red"></i>
												{{ $t('preview') }}</ts-button>
										</div>
									</div>
								</fieldset>
							</form>
						</ts-loading-banner>
					</ts-card-wrapper>
				</ts-card>
			</div>
			<div class="col-md-9">
				<ts-card>
					<ts-card-wrapper>
						<form>
							<fieldset>
								<legend>{{ $t('monthlyExpenseItem.preview') }}</legend>
								<ts-preview-pdf v-model="waiting" :src="src" />
							</fieldset>
						</form>
					</ts-card-wrapper>
				</ts-card>
			</div>
		</div>
	</div>
</template>
  
<script>
import { Errors } from 'form-backend-validation'
import moment from 'moment'
import { mapActions } from 'vuex'
import * as FileDownload from 'downloadjs'
import { trim } from 'lodash'

export default {
	name: 'monthlyExpenseItem',
	data() {
		return {
			loading: false,
			waiting: false,
			exporting: false,
			employeeLoading: false,
			src: null,
			errors: new Errors(),
			items: [],
			locations: [],
			categories: [],
			employees: [],
			branches: [],
			mode: ['month', 'month'],
			month_range: [moment().startOf('year'), moment().endOf('year')],
			model: {
				exp_id: undefined,
				exp_cat_id: undefined,
				employee_id: undefined,
				location_id: undefined,
				branch_id: undefined,
				report_type: 1,
				month_range: [
					moment().startOf('year').format('MM-YYYY'),
					moment().endOf('year').format('MM-YYYY')
				]
			},
			reportTypes: [
				{
					value: 1,
					label: 'Details'
				},
				{
					value: 2,
					label: 'Summary'
				}
			]
		}
	},
	created() {
		this.fetchData()
	},
	methods: {
		...mapActions('report/expense', ['monthlyExpenseItem', 'getExpenseItem', 'getExpCategory', 'getEmployee']),
		async fetchData() {
			this.loading = true
			await this.getExpCategory().then(response => {
				this.categories = response.data.map(el => ({
					value: el.exp_cat_id,
					label: el.exp_category
				}))
			})
			await this.getExpenseItem()
				.then(response => {
					this.items = response.data.map(el => ({
						value: el.exp_id,
						label: el.exp_item
					}))
				})
				.finally(() => {
					this.loading = false
				})
			await this.getEmployee()
				.then(response => {
					this.employees = response.data.map(el => ({
						value: el.employee_id,
						label: el.employee_name_en
					}))
				})
				.catch(error => {
					this.$toasted.error(error.message)
				})
				.finally(() => {
					this.loading = false
				})
			await this.$store
				.dispatch('report/resource/getBranch')
				.then(response => {
					this.branches = response.data.map(el => ({
						value: el.branch_id,
						label: el.branch_name_en
					}))
				})
				.catch(error => {
					this.$toasted.error(error.message)
				})
				.finally(() => {
					this.loading = false
				})
		},
		handlePanelChange(value, mode) {
			this.month_range = value
			this.model.month_range[0] = moment(value[0]).format('MM-YYYY')
			this.model.month_range[1] = moment(value[1]).format('MM-YYYY')
			this.mode = [
				mode[0] === 'date' ? 'month' : mode[0],
				mode[1] === 'date' ? 'month' : mode[1]
			]
		},
		onChangeBranch() {
			this.loading = true
			this.locations = []
			this.model.location_id = undefined
			this.$store
				.dispatch('report/resource/getLocation', {
					branch_id: this.model.branch_id
				})
				.then(response => {
					this.locations = response.data.map(el => ({
						value: el.location_id,
						label: el.location_name_en
					}))
				})
				.finally(() => {
					this.loading = false
				})
		},
		preview() {
			this.waiting = true
			this.src = ''
			this.errors = new Errors()
			this.monthlyExpenseItem(this.model)
				.then(response => {
					this.src = response.url
				})
				.catch(error => {
					this.$toasted.error(error.message)
					this.errors = new Errors(error.errors)
				})
				.finally(() => {
					this.waiting = false
				})
		},
		exportExcel() {
			this.exporting = true
			this.errors = new Errors()
			this.$store
				.dispatch('report/expense/monthlyExpenseItemExcel', this.model)
				.then(response => {
					let filename = trim(
						response.headers['content-disposition']
							.substring(
								response.headers['content-disposition'].indexOf('filename')
							)
							.replace('filename=', ''),
						'"'
					)
					FileDownload(response.data, filename)
				})
				.catch(err => {
					let error = JSON.parse(
						String.fromCharCode.apply(null, new Uint8Array(err))
					)
					this.$toasted.error(error.message)
					this.errors = new Errors(error.errors)
				})
				.finally(() => (this.exporting = false))
		},
	}
}
</script>